export const Switch = {
  baseStyle: {
    onTrackColor: 'primary.500',
    onThumbColor: 'white'
  },
  sizes: {
    sm: {
      style: {
        transform: [{ scale: 0.75 }]
      }
    },
    md: {},
    lg: {
      style: {
        transform: [{ scale: 1 }]
      }
    }
  }
}
